export const getScopeOptions = (isCreateMode?: boolean) => {
  const options = [
    "Orders",
    "Customers"
  ].sort();

  return isCreateMode ? ["Select Record", ...options] : options;
};